module.exports = __webpack_public_path__ + "static/img/c1.20ce471.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/wave/c1.png
// module id = 0zJS
// module chunks = 0